import { PLATFORM_ENDPOINTS } from "../../constants";
import { trimEndSlash, makeTokenRequest, getTokenRequestParameters } from "../../helpers";
export class PlatformRequestService {
    constructor(url, siteId, ajaxService) {
        this.baseAnynomousApiUrl = url;
        this.siteId = siteId;
        this.ajaxService = ajaxService;
    }
    ;
    getAnonymousToken() {
        return makeTokenRequest(this.ajaxService, getTokenRequestParameters(`${trimEndSlash(this.baseAnynomousApiUrl)}/${trimEndSlash(PLATFORM_ENDPOINTS.ANONYMOUS)}/${this.siteId}`, this.getParsedToken.bind(this)));
    }
}
//# sourceMappingURL=PlatformRequestService.js.map